module.exports = "/_next/static/images/4bee55dff492f642334c9ee4e37d5400-paperwork@mobile480.jpg.webp";